import {useContext} from 'react'
import FlechaDescargar from '../../imagenes/flechaDescargar.png'
import {ContextoAplicacion} from '../../contexto'
import {GenerarReporteConEnvioCorreo} from '../Reportes'

const SolicitarExportarMovimientos = ({texto, exportarDatos}) => {
  const contextoAplicacion = useContext(ContextoAplicacion)

  const manejarObtenerDatos = async (e) => {
    e.stopPropagation()
    contextoAplicacion.setModal({
      abierto: true,
      titulo: '',
      contenido: (
        <GenerarReporteConEnvioCorreo
          titulo={'Generar reporte del movimiento'}
          funcionEjecutar={exportarDatos}
        />
      ),
      botones: [],
    })
  }

  return (
    <div className="w-full flex flex-wrap justify-center items-center ">
      <button
        onClick={(e) => manejarObtenerDatos(e)}
        className="bg-cendiatra flex justify-center items-center h-12 w-36 text-white rounded flex-nowrap p-1"
      >
        <img src={FlechaDescargar} alt="descargar" />
        <span>{texto} </span>
      </button>
    </div>
  )
}

export default SolicitarExportarMovimientos
